import React, { Component } from "react";
import "./header/Header.css"; 
import "../scss/general.css"
import Moment from "moment";
import ModalLogin from './ModalLogin';
import Mymodal from './modalleave';
import config from '../config';
import Modal from "react-bootstrap/Modal"
import modallogo from "./images/loader.gif";
import BusyModal from "./modalwait";
import logo from "./images/loading.gif";
import Cookies from "universal-cookie";
import Helmet from 'react-helmet';
import DayPicker, { DateUtils } from "react-day-picker";
import 'react-day-picker/lib/style.css';
import "../scss/radio.scss" ;
const  axios = require("axios");
const cookies = new Cookies();
const columns = [
{
    field: "name",
    header: "Name",
    width: "200px",
},
{
    field: "designation",
    header: "Designation",
    width: "200px",
},
];

const initialState={
  input:{},
  myitems:[],
  leavedata:{},
  monthstart:0,
  yearstart:0,
  tLeave:0,
  isLoaded: false,
  isData: false,
  fromDate: new Date(),
  toDate: new Date(),
  fdate: Moment(new Date()).format("DD/MM/YYYY"),
  tdate: Moment(new Date()).format("DD/MM/YYYY"),
  Afdate: Moment(new Date()).format("DD/MM/YYYY"),
  Atdate: Moment(new Date()).format("DD/MM/YYYY"),
  fromTime:0,toTime:0,
  from_time:"9:00 AM",to_time:"5:00 PM",
  leaveDays:0,
  options:false,
  AAnnual:0,ASick:0,ACasual:0,ALWP:0,ACMP:0,
  DateED:false,
  edsubmit:true,
  from: undefined,
  to: undefined,
  div1:"block",
  div2:"none",
  selectedDays:[],
  optionValue:"C",
  leavetype:"Casual",
  toname:"",
  toemail:"",
  error:"",
  errorcss:"labelerror",
  textreason:"",
  disDIV:"none",
  authority:[],
  isOpen:false,
  authorityD:[{"emp_id":"1","name":"CE","designation":"Chief Executive",email:"Khalil.Sattar@KandNs.com"},{"emp_id":"2","name":"ED","designation":"Executive Director",email:"Adil.Sattar@KandNs.com"}],
  ErrMsg:"",
  ErrMsg2:"",
  status:0,
  modifiertext:"",
  getItems:[],
  myholidays:{holidays:[]},
  myholidaysStyles:{holidays: {color: 'white',backgroundColor: '#ffc107',}},  
  holidaytext:"",
  holidayfrom:new Date(),
  holidayto:new Date(),
  holidaystatus:0,
  St:0 

}
class LeaveapplicationSelf extends Component
{
  static defaultProps = {
    numberOfMonths: 2,
  };
  constructor(props)
  {
      super(props);
      this.state=initialState;
      this.handlechangefrom = this.handlechangefrom.bind(this);
      this.handlechangeto = this.handlechangeto.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleoptionclick = this.handleoptionclick.bind(this);
      this.handleProceed = this.handleProceed.bind(this);
      this.handleClear = this.handleClear.bind(this);
      this.handleDayClick = this.handleDayClick.bind(this);
      this.handleDayClick2 = this.handleDayClick2.bind(this);
      this.handleTextChange = this.handleTextChange.bind(this);
      this.optionG = this.optionG.bind(this);
      this.optionD = this.optionD.bind(this);
      this.ErrHandler = this.ErrHandler.bind(this);
  }
  ErrHandler(){
      this.setState({...initialState});
      this.componentDidMount();
  } 
  optionG(e){

      this.setState({ toname:this.state.authority[e.target.value].name,toemail:this.state.authority[e.target.value].email,edsubmit:false});
  }
  optionD(e){
      this.setState({toname:this.state.authorityD[e.target.value].name,toemail:this.state.authorityD[e.target.value].email,edsubmit:false});
  }
  handleTextChange(e){
      this.setState({textreason:e.target.value});
  }
  handleDayMouseEnter=(day)=>{
    let newDate=Moment(day).format("DD/MM/YYYY");
    let arrayitem=this.state.getItems;
    this.setState({holidaytext:""});
    let ii=0;
    while(ii < arrayitem.length)
    {
      if(newDate==Moment(arrayitem[ii]["cdate"]).format("DD/MM/YYYY"))
      {
        this.setState({holidaytext:arrayitem[ii]["holidays"]});
      }
      
      ii++;

    }
  }

  componentDidMount()
  {
      this.setState({ErrMsg:<img src={logo} alt=''/>,ErrMsg2:""});
      if(cookies.get("LoginID"))
      {
          document.body.style.cursor="wait";
          let input=this.state.input;
          input["ID"]=cookies.get("LoginID");
          input["IDM"]=cookies.get("LoginID");
          this.setState({isLoaded: false});
          axios.all([
              axios({
              method: 'post',
              url: cookies.get("phpclass")+'/index.php/user/get_leave/'+cookies.get("LoginID"),
              headers: {'Content-Type': 'multipart/form-data'}
              }),
              axios({
                method: 'post',
                url: cookies.get("phpclass")+'/index.php/user/LeaveAuthority/'+cookies.get("LoginID"),
                headers: {'Content-Type': 'multipart/form-data'}
              }),
              axios({
                method: 'get',
                url: cookies.get("phpclass")+'/index.php/user/get_holidays2/'+cookies.get("LoginID"),
                headers: {'Content-Type': 'multipart/form-data'}
              })
            ])
           .then(axios.spread((response1,response2,response3)=> {
                document.body.style.cursor="default";
                input["Desig"]=response1.data[0].DESIG;
                input["Location"]=response1.data[0].LOCATION;
                input["Email"]=response1.data[0].LOGINEMAIL;
                input["Name"]=response1.data[0].NAME;                
                let leavedata=this.state.leavedata;
                leavedata["TAnnual"]=Number(response1.data[0].BF_ANNUAL)+Number(response1.data[0].ANNUAL)-Number(response1.data[0].E_ANNUAL)-Number(response1.data[0].L_ANNUAL);
                leavedata["TCasual"]=Number(response1.data[0].CASUAL)-Number(response1.data[0].E_CASUAL)-Number(response1.data[0].L_CASUAL);
                leavedata["TSick"]=Number(response1.data[0].SICK)-Number(response1.data[0].E_SICK)-Number(response1.data[0].L_SICK);
                leavedata["TLWP"] = 0;
                leavedata["TCMP"] = 0;
                this.setState({authority:response2.data,leavedata,isLoaded: true,ErrMsg:"", monthstart: response1.data[0].mperiodstart,yearstart:response1.data[0].yperiodstart});

                let myholidays=this.state.myholidays;    
                let i=0;
                while(i < response3.data.length)
                {
      
                  myholidays.holidays.push(new Date(response3.data[i]["cdate"]));
                  this.setState({myholidays});
                  i++;
        
                }
                this.setState({getItems:response3.data});
            }))
            .catch(()=> {
                document.body.style.cursor="default";          
                this.setState({ErrMsg:"",ErrMsg2: <Mymodal handler = {this.handleClear} Type="1" Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});
            })      
        }
        else
        {
           this.setState({ErrMsg:<ModalLogin />,isLoaded:false});   
        }    
    }    
    handleoptionclick=(e)=>
    {
      let evalue=e.target.value;
      this.setState({AAnnual:0,ASick:0,ACasual:0,ALWP:0,ACMP:0,edsubmit:true,leaveDays:0,selectedDays:[],from:undefined,to:undefined});
      if(evalue === "A")
        this.setState({optionValue:evalue, div1:"none",div2:"block",leavetype:"Annual"});
      if(evalue === "S")
        this.setState({optionValue:evalue,div1:"none",div2:"block",leavetype:"Sick"});
      if(evalue === "C")
        this.setState({optionValue:evalue,div1:"block",div2:"none",leavetype:"Casual"});
      if(evalue === "CP")
        this.setState({optionValue:evalue,div1:"block",div2:"none",leavetype:"Compensatory"});
      if(evalue === "LWP")
        this.setState({optionValue:evalue,div1:"block",div2:"none",leavetype:"LWP"});
    }

    handlechangefrom(date)
    {
      console.log(date);
      this.setState({fdate:Moment(date).format("DD/MM/YYYY"),disDIV:"none"});
    }
    handlechangeto(date)
    {
      this.setState({tdate:Moment(date).format("DD/MM/YYYY"),disDIV:"none"});
      this.setState({toDate:date});
    }
     timeChangeFrom=(event)=>{
      this.setState({fromTime:Number(event.target.value),disDIV:"none",status:0});
    }    
    timeChangeTo=(event)=>{
      this.setState({toTime:Number(event.target.value),disDIV:"none",status:0});
    }    
    cur=(num)=> {
      let cnum=parseInt(num,0);
      if(num > 0)
        return num.toFixed(1).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      else
        return "-"
    }

    handleDayClick2(day) {
      let cday=day.toString();
      let holidayfrom,holidayto = new Date()
      let arrayitem=this.state.getItems;
      let ii,holidaystatus=0;      
      const range = DateUtils.addDayToRange(day, this.state);
      if(range.to === undefined || range.to === null)
        range.to = range.from;
        holidayfrom=new Date(range.from);
        holidayto=new Date(range.to);
        holidayfrom=new Date(holidayfrom.setDate(holidayfrom.getDate() - 1 ))
        holidayto=new Date(holidayto.setDate(holidayto.getDate() + 1 )) ;
        ii=0;
        while(ii < arrayitem.length)
        {
          if(Moment(holidayfrom).format("DD/MM/YYYY")==Moment(arrayitem[ii]["cdate"]).format("DD/MM/YYYY") || Moment(holidayto).format("DD/MM/YYYY")==Moment(arrayitem[ii]["cdate"]).format("DD/MM/YYYY"))
          {
//            console.log(arrayitem[ii]["holidays"]);
            holidaystatus=1;
            //this.setState({holidaytext:arrayitem[ii]["holidays"]});
          }
          ii++;
        }      
        this.setState({holdayfrom:holidayfrom,holidayto:holidayto,holidaystatus:holidaystatus});
        
      this.setState(range);

      let days=0
      if(range.from === null && range.to === null)
        days=0;
      else
        days=Math.ceil((range.to - range.from) / 8.64e7) + 1;
      this.setState({leaveDays: days,disDIV:"none",status:0});
  }    
  handleDayClick(day, { selected }) {
    let dday=day.toString();
    let dd = new Date(day);
    let newDate=Moment(day ).format("DD/MM/YYYY");
    let arrayitem=this.state.getItems;
    let hcount=0;
    this.setState({holidaytext:""});
    let ii=0;
    while(ii < arrayitem.length)
    {
      if(newDate==Moment(arrayitem[ii]["cdate"]).format("DD/MM/YYYY"))
      {
        this.setState({holidaytext:arrayitem[ii]["holidays"]});
        hcount=1;
      }
  
      ii++;
    }


      //let hcount=this.state.hcount;
      if(dday.substring(0,3) !== "Sun" && hcount==0)
      {
        const selectedDays = this.state.selectedDays.concat();
        if (selected) {
          const selectedIndex = selectedDays.findIndex(selectedDay =>
          DateUtils.isSameDay(selectedDay, day)
        );
          selectedDays.splice(selectedIndex, 1);
        } else {
          selectedDays.push(day);
        }
      this.setState({selectedDays,leaveDays: selectedDays.length,disDIV:"none",status:0 });
      }
  }

    handleProceed()
    {

      let  to,from = undefined;

      this.setState({edsubmit:true,status:1});
      if(this.state.leaveDays == 0)
      {
        this.setState({error:"Must select leave date",errorcss:"labelerror"});
        return;
      }
      if(this.state.leavetype === "Casual")
      {
        from = this.state.from.toString();
        from = from.substring(0,3);
        if(this.state.to !== undefined)
        {
          to =this.state.to.toString();
          to=to.substring(0,3);
        }
        else
        {
          to=from;
        }
      }

      if(this.state.to==undefined && (this.state.leavetype=="Casual" || this.state.leavetype=="Compensatory" || this.state.leavetype=="LWP" ) )
      {
        this.setState({to:this.state.from,disDIV:""});

      }  
      let days=this.state.leaveDays;
      let leavedata = this.state.leavedata;
      let lwp=0;
      if(days > 3 && this.state.optionValue === "C")
      {
        this.setState({error:"As per policy, maximum 3 consecutive Casual leaves can be approved.",errorcss:"labelerror"});
      }
      else if(days > 0 )
      {
        this.setState({error:"",errorcss:"labelfail",disDIV:""});
        if(this.state.fromTime === 4)
          {
            days=days - 1 + .5;
            this.setState({fromTime:1,from_time:"1:00 PM"});
          }
        if(this.state.toTime === 4)
          {
            days=days - 1 + .5;
            this.setState({toTime:1,to_time:"1:00 PM"});}
          if(this.state.fromTime === 8)
          {
            days=days - .5 + 1;
            this.setState({fromTime:0,from_time:"9:00 AM"});
          }
          if(this.state.toTime === 8)
          {
            days=days - .5 + 1;
            this.setState({toTime:0,to_time:"5:00 PM"});
          }
        if(this.state.optionValue === "A")
        {
          lwp = days - this.state.leavedata["TAnnual"];
          if(this.state.leavedata["TAnnual"] < days)
          {
              this.setState({error:"You do not have enough leave balance.",errorcss:"labelerror",to:undefined,from:undefined,ACasual:0,leaveDays:0,disDIV:"none"});
              return;
          }
          else
            this.setState({AAnnual: days,ACasual:0,ASick:0,ALWP:0,ACMP:0});
        }
        if(this.state.optionValue === "C")
        {
          if((to == "Sat" || from == "Mon") && days == parseInt(days) )
          {
            this.setState({error:"As per policy, you must combine Sunday with Saturday or Monday for casual leave.",errorcss:"labelerror",to:undefined,from:undefined,ACasual:0,leaveDays:0,disDIV:"none"});
            return;
          }
          else if(this.state.holidaystatus == 1 && days == parseInt(days))
          {
            this.setState({error:"As per policy, you must combine holiday with your casual leave.",errorcss:"labelerror",to:undefined,from:undefined,ACasual:0,leaveDays:0,disDIV:"none"});
            return;
          }
          else
          {
            this.setState({error:"",errorcss:"labelerror"});
          }
          lwp = days - this.state.leavedata["TCasual"];
          if(this.state.leavedata["TCasual"] < days)
          {
            this.setState({error:"You do not have enough leave balance.",errorcss:"labelerror",to:undefined,from:undefined,ACasual:0,leaveDays:0,disDIV:"none"});
            return;
  //          this.setState({ACasual: days-lwp,AAnnual:0,ASick:0,ALWP:lwp,ACMP:0});
          }
          else
            this.setState({ACasual: days,AAnnual:0,ASick:0,ALWP:0});
        }
        if(this.state.optionValue === "S")
        {
          lwp = days - this.state.leavedata["TSick"];
          if(this.state.leavedata["TSick"] < days)
          {
            this.setState({error:"You do not have enough leave balance.",errorcss:"labelerror",to:undefined,from:undefined,ACasual:0,leaveDays:0,disDIV:"none"});
            return;
          }
          else
            this.setState({ASick: days,AAnnual:0,ACasual:0,ALWP:0});
        }
        if(this.state.optionValue === "CP")
        {
          this.setState({ACMP: days,AAnnual:0,ACasual:0,ALWP:0,Asick:0});
        }
        if(this.state.optionValue === "LWP")
        {
          lwp=0;
          this.setState({ACMP: 0,AAnnual:0,ACasual:0,ALWP:days,Asick:0});
        }
        if(lwp > 0)
          this.setState({leaveDays:days-lwp,leavedata});
        else
          this.setState({leaveDays:days,leavedata});
      }

///////
      if(this.state.leavetype=="Casual" || this.state.leavetype=="Compensatory" || this.state.leavetype=="LWP" ) 
      {
        let ll = 0 
        let sDate=this.state.from;
        const newDate = new Date(sDate.getTime());
        this.setState({selectedDays:[]});
        let selectedDays = this.state.selectedDays;
        while(ll < this.state.leaveDays)
        {
          var adate=newDate.setDate(sDate.getDate() + ll);
          selectedDays.push(new Date(adate));
          ll++;
        }
        this.setState({selectedDays});
      }


    }
    handleClear()
    {
      this.setState({ErrMsg2:""});
      if(this.state.St === 1)
      {
        this.setState({...initialState});
        this.componentDidMount();
      }
    }
    handleSubmit()
    {
      if(this.state.status===1)
      {
        this.setState({ErrMsg2: <BusyModal />});
        let sdays=this.state.selectedDays; 
        sdays.sort((a,b) => (a > b) ? 1 : -1)
        let input=this.state.input;
        let ii=0;
        let lenarray=sdays.length;
        
        sdays.forEach((sdays) => {
        if(ii==0 && this.state.fromTime==1)      
          input["time"+ii]=0.5;
        else if(ii==lenarray - 1 && this.state.toTime==1)
          input["time"+ii]=0.5;
        else
          input["time"+ii]=1;
          input["ddays"+ii]=Moment(sdays).format("DD/MM/YYYY");
          ii+=1;
        })
        this.setState({input});
        if(this.state.leavetype=="Casual" || this.state.leavetype=="Compensatory" || this.state.leavetype=="LWP")
        {
          input["fromDate"]=Moment(this.state.from).format("DD/MM/YYYY");
          input["toDate"]=Moment(this.state.to).format("DD/MM/YYYY");
        }
        else
        {
          var maxDate=new Date(Math.max.apply(null,this.state.selectedDays));
          var minDate=new Date(Math.min.apply(null,this.state.selectedDays));
          input["fromDate"]=Moment(minDate).format("DD/MM/YYYY");
          input["toDate"]=Moment(maxDate).format("DD/MM/YYYY");
        }
        input["days"]=this.state.leaveDays;
        input["fromTime"]=this.state.from_time;
        input["toTime"]=this.state.to_time;
        input["LWP"]=this.state.ALWP;
        input["reason"]=this.state.textreason;
        input["toemail"]=this.state.toemail;
        input["toname"]=this.state.toname;
        input["annual"]=this.state.leavedata["TAnnual"];
        input["casual"]=this.state.leavedata["TCasual"];
        input["sick"]=this.state.leavedata["TSick"];
        input["by"]=cookies.get("LoginID");

        let tday=this.state.fromDate.toLocaleString("en-us", { day: "2-digit" });
        let tmonth=this.state.fromDate.toLocaleString("en-us", { month: "2-digit" });
        let tyear=this.state.fromDate.getFullYear();
        let randomdate=parseInt(tday)+parseInt(tmonth)+parseInt(tyear)+100112;
        input["formid"]=Math.floor(randomdate + Math.random() * 9000);
        if(this.state.leaveDays == 0)    
          input["leavetype"]="";
        else
          input["leavetype"]=this.state.leavetype;
          this.setState({input});
          console.log(input);
          document.body.style.cursor="wait";
          axios({
            method: 'post',
            url: cookies.get("phpclass")+'/index.php/user/Submitleave2/',
            data: this.state.input,
            headers: {'Content-Type': 'multipart/form-data'}
          })
          .then((response)=> {
            document.body.style.cursor="default";
            console.log(response.data);
            if(response.data === "2")
            {
              document.body.style.cursor="default";
              this.setState({isOpen:false,St:1,ErrMsg2:<Mymodal Type="0" handler = {this.handleClear} Title="Success" Body="Your request for leave approval sent successfully."/>});
            }         
            else 
            {   
              document.body.style.cursor="default";
              this.setState({isOpen:false,St:0, ErrMsg2:<Mymodal Type="1" Title="Failed" handler = {this.handleClear} Body="There might be a connection issue. Please try again."/>});
            }
          })
          .catch((response)=> {
            document.body.style.cursor="default";
            this.setState({isOpen:false,St:0,ErrMsg2:<Mymodal Type="1" Title="Failed" handler={this.handleClear} Body="Transaction is not possible this time, please try after few minutes"/>});
          });
      }
      else
      {
        document.body.style.cursor="default";
        this.setState({isOpen:false,St:0,ErrMsg2:<Mymodal Type="1" Title="Failed" handler={this.handleClear} Body="Please press the <Proceed> button to update the leave balance."/>});
    
      }
    }  
 render()
 {
    const { from, to } = this.state;
    const modifiers = { start: from, end: to };
    let items=this.state.authority;
    let itemsD=this.state.authorityD;
    let isLoaded =this.state.isLoaded;
    if(this.state.ErrMsg.length > 5)
      return(<div>{this.state.ErrMsg}</div>)      
    if (!isLoaded) 
    {    

      return(
        <div className={config.changeDivClass}>
        <div className="center">
           {this.state.ErrMsg}
        </div>
        </div>
      );    
    } 
    else 
    {
      return (
        <div className="container1">
        {this.state.ErrMsg}
        <br></br>                             
        <div style={{width:"100%",textAlign:"center",align:"center"}} >
        <br></br>
        <div className="inner-profile">
        <h5>Leave Application Form</h5>
          <table style={{width:"100%",marginTop:"15px"}}>
          <thead></thead>
          <tbody>
            <tr>
              <td className="th" style={{width:"80px"}}>Apply for</td>
              <td className="th" ><input type="radio" className="radio" value="A" name="leaveb" disabled={this.state.options} onChange={this.handleoptionclick} id="Annual"/><label htmlFor="Annual" className="label2"> Annual</label></td>
              <td className="th" ><input type="radio" className="radio" value="C" name="leaveb" defaultChecked disabled={this.state.options} onChange={this.handleoptionclick} id="Casual"/> <label htmlFor="Casual" className="label2"> Casual</label></td>
              <td className="th" ><input type="radio" className="radio" value="S" name="leaveb" disabled={this.state.options} onChange={this.handleoptionclick} id="Sick"/> <label htmlFor="Sick" className="label2"> Sick</label></td>
{/*}              <td className="th" ><input type="radio" className="radio" value="CP" name="leaveb" disabled={this.state.options} onChange={this.handleoptionclick} id="Comp"/> <label htmlFor="Comp" className="label2"> Compensatory</label></td>*/}
              <td className="th" ><input type="radio" className="radio" value="LWP" name="leaveb" disabled={this.state.options} onChange={this.handleoptionclick} id="LWP"/> <label htmlFor="LWP" className="label2"> L W P</label></td>
            </tr>
            </tbody>
          </table>
          <marquee width="100%" direction="left"  color="Red">New leave application will close the previous (pending) application</marquee>
          <div style={{marginTop:"10px",marginBotton:"15px",width:"100%", backgroundColor:"black", color:"white", textAlign:"center",display:this.state.div1}}>
              <DayPicker
                className="Selectable"
                month = {new Date()}
                
                fixedWeeks
                numberOfMonths={this.props.numberOfMonths} pagedNavigation
                selectedDays={[from, { from, to }]}
                modifiers={this.state.myholidays}
                modifiersStyles={this.state.myholidaysStyles}
                onDayMouseEnter={this.handleDayMouseEnter}

                onDayClick={this.handleDayClick2}

              />

              <Helmet>
              <style>{`
                .Selectable .DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside) {
                background-color: #f0f8ff !important;
                color: #4a90e2;
                }
                .Selectable .DayPicker-Day {border-radius: 20% !important;}
                .Selectable .DayPicker-Day--start {border-top-left-radius: 20% !important; border-bottom-left-radius: 50% !important;}
                .Selectable .DayPicker-Day--end {border-top-right-radius: 20% !important;border-bottom-right-radius: 50% !important;}
                `}</style>
              </Helmet> 

              <table style={{width:"100%"}}>
              <thead></thead>
              <tbody>
                <tr>
                  <td style={{width:"50%",textAlign :"center", padding:"1px" ,color:"white"}}>Leave start time:
                    <select onChange={this.timeChangeFrom} disabled={this.state.DateED}>
                      <option value="8">9:00 AM</option>
                      <option value="4">1:00 PM</option>
                      </select>                          
                  </td>
                  <td style={{width:"50%",textAlign:"center", padding:"1px" ,color:"white"}}>Leave end time:
                    <select onChange={this.timeChangeTo} disabled={this.state.DateED}>To
                      <option value="8">5:00 PM</option>
                      <option value="4">1:00 PM</option>
                      </select>                          
                  </td>
                </tr>
                <tr>
                  <td style={{color:"#ffc107",fontWeight:"bold",textAlign:"center",backgroundColor:"black",fontSize:12,height:20 }} colSpan={2}>{this.state.holidaytext}

                  </td>
                </tr>
                </tbody>
              </table>
              <br></br>
            </div>
            <div style={{marginTop:"10px",marginBotton:"15px",width:"100%", backgroundColor:"black", color:"white",display:this.state.div2}}>
              <DayPicker
                selectedDays={this.state.selectedDays}
                onDayClick={this.handleDayClick}
                month={new Date()}
                fixedWeeks
                numberOfMonths={this.props.numberOfMonths} pagedNavigation
                modifiers={this.state.myholidays}
                modifiersStyles={this.state.myholidaysStyles}
                onDayMouseEnter={this.handleDayMouseEnter}
                          
              />
{/*}              <Helmet/>*/}
              <table style={{width:"100%"}}>
              <thead></thead>
              <tbody>
                <tr>
                  <td style={{width:"50%",textAlign:"center", padding:"1px" ,color:"white"}}>Leave start time: 
                    <select onChange={this.timeChangeFrom} disabled={this.state.DateED}>
                      <option value="8">9:00 AM</option>
                      <option value="4">1:00 PM</option>
                    </select>                          
                  </td>
                  <td style={{width:"50%",textAlign:"center", padding:"1px" ,color:"white"}}>Leave end time: 
                    <select onChange={this.timeChangeTo} disabled={this.state.DateED}>To
                      <option value="8">5:00 PM</option>
                      <option value="4">1:00 PM</option>
                    </select>                          
                  </td>
                </tr>
                <tr>
                  <td style={{color:"#ffc107",fontWeight:"bold",textAlign:"center",backgroundColor:"black",fontSize:12,height:20 }} colSpan={2}>{this.state.holidaytext}

                  </td>
                </tr>
                </tbody>
              </table>
              <br></br>

            </div>
            <div style={{float:"center",marginBotton:"10px",marginTop:"2px",width:"100%",textAlign:"center"}}>
              <span className={this.state.errorcss} align="left">{this.state.error}</span>

                <button onClick={this.handleProceed} className="btn btn-secondary active" disabled={this.state.DateED}>Proceed</button>
                <br></br>
            </div>
            <br/>
            <table style={{width:"100%",textAlign:"left"}}  >
              <thead >
                <tr >
                  <th className="thm" scope="col"></th>
                  <th className="thm" scope="col">ANNUAL</th>
                  <th className="thm" scope="col">CASUAL</th>
                  <th className="thm" scope="col">SICK</th>
                  <th className="thm" scope="col">LWP</th>
                  <th className="thm" scope="col">CMP</th>
                  <th className="thm" scope="col">TOTAL</th>
                </tr>
              </thead>
              <tbody >
                <tr>
                  <td className="tddesc" >Balance B/F</td>
                  <td className="tdamb" >{this.cur(this.state.leavedata["TAnnual"])}</td>
                  <td className="tdamb" >{this.cur(this.state.leavedata["TCasual"])}</td>
                  <td className="tdamb" >{this.cur(this.state.leavedata["TSick"])}</td>
                  <td className="tdamb" >{this.cur(0)}</td>
                  <td className="tdamb" >{this.cur(0)}</td>
                  <td className="tdamb" >{this.cur(Number(this.state.leavedata["TSick"])+Number(this.state.leavedata["TCasual"])+Number(this.state.leavedata["TAnnual"]))}</td>
                </tr>
                <tr>
                  <td className="tddesc">Apply for</td>
                  <td className="tdamb">{this.cur(this.state.AAnnual)}</td>
                  <td className="tdamb">{this.cur(this.state.ACasual)}</td>
                  <td className="tdamb">{this.cur(this.state.ASick)}</td>
                  <td className="tdamb">{this.cur(this.state.ALWP)}</td>
                  <td className="tdamb">{this.cur(this.state.ACMP)}</td>
                  <td className="tdamb">{this.cur(this.state.ASick+this.state.ACasual+this.state.AAnnual+this.state.ALWP+this.state.ACMP)}</td>
                </tr>
                <tr>
                  <td className="tdhead" ><b>Balance</b></td>
                  <td className="tdambhead" >{this.cur(this.state.leavedata["TAnnual"]-this.state.AAnnual)}</td>
                  <td className="tdambhead" >{this.cur(this.state.leavedata["TCasual"]-this.state.ACasual)}</td>
                  <td className="tdambhead" >{this.cur(this.state.leavedata["TSick"]-this.state.ASick)}</td>
                  <td className="tdambhead" >{this.cur(0)}</td>
                  <td className="tdambhead" >{this.cur(0)}</td>
                  <td className="tdambhead" >{this.cur(Number(this.state.leavedata["TSick"])+Number(this.state.leavedata["TCasual"])+Number(this.state.leavedata["TAnnual"]-(this.state.AAnnual+this.state.ACasual+this.state.ASick)))}</td>
                </tr>
              <tr>
                <td colSpan="7">
                  <label htmlFor="story" ><b>Reason or Purpose:</b></label>
                  <div width="100%">
                    <textarea name="textValue" title="Reason or Purpose"  onChange={this.handleTextChange} style={{width:"100%", height:"100px"}} />
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan="4"><b>Approval authority</b></td>
                <td colSpan="3"><b>for direct reporting</b></td>
              </tr>
              <tr>
                <td colSpan="4" >
                <div style={{width:"100%",textAlign:"left", height:"150px",overflow:"auto",border:"gray solid 1px", float:"left",pointerEvents:this.state.disDIV}} id="control5">
                  <table style={{width:"100%",marginLeft:"5p"}} >
                  <tbody>
                    {items.map((result ,i) => {
                    return (
                      <tr className="trc" key={i}>
                        <td style={{width:"95%",paddingLeft:"5px"}}><input  id={result.name} type="radio" className="radio" value={i} name="inputopt" onChange={this.optionG}/><label className="lebel2" htmlFor={result.name}>{result.name}</label></td>
                      {/*}  <td style={{width:"44%"}}>{result.designation}</td>*/}
                      </tr>
                    )})}
                  </tbody>
                  </table>
                </div>
                    </td>
                <td colSpan="3">
                <div style={{width:"100%",textAlign:"left",height:"150px",overflow:"auto",border:"gray solid 1px", float:"left",pointerEvents:this.state.disDIV}} id="control5">
                  <table style={{width:"100%",marginLeft:"5p"}} >
                  <tbody>
                    {itemsD.map((result ,i) => {
                    return (
                      <tr className="trc" key={i}>
                        <td style={{width:"56%",paddingLeft:"5px"}}><input  id={result.name} type="radio" className="radio" value={i} name="inputopt" onChange={this.optionD}/><label className="lebel2" htmlFor={result.name}>{result.designation}</label></td>
                      </tr>
                    )})}
                  </tbody>
                  </table>
                </div>
                </td>
              </tr>
              </tbody>
            </table>
            <br/>
            <div style={{paddingTop:"2px", width:"100%",textAlign:"center"}} >
                <button onClick={this.handleSubmit} className="btn btn-secondary active" disabled={this.state.edsubmit}>Submit</button>
                <div style={{width:"5px", height:"auto", display:"inline-block"}}/>
                  <button onClick={this.handleClear} className="btn btn-secondary active">Clear</button>
            </div>
          </div>
        </div>
        {this.state.ErrMsg2}
        <Modal show={this.state.isOpen}  animation="false" centered backdrop="static" size="sm">
        <Modal.Body><img src={modallogo} width="30px" height="30px"/><span style={{PaddingLeft:"15px"}}>Please wait...</span></Modal.Body>
        </Modal>
      </div>
    );
  }
}
}
export default LeaveapplicationSelf;